















import { Vue, Component, Prop } from 'vue-property-decorator';

interface ITab {
  label: string;
  value: string;
}

@Component({})
export default class Tabs extends Vue {
  @Prop({ required: true }) tabs!: ITab[];
  @Prop({ required: true }) value!: string;
  @Prop({ default: '100%' }) height!: string;
}
